<template>
  <div class="wrapper" :class="'wrapper-' + $store.getters.platform">

    <div v-if="!$store.getters.user" class="text-no-login">
      <h6 class="text-black-shadow">{{$t('SHOP.NO-LOGIN')}}</h6>
    </div>
    <div v-else>

      <Loader v-if="!cart"></Loader>
      <div v-else>
        <router-view :key="$route.fullPath" />
        <!-- products card -->
        <div v-if="!cart.products_cart.length" class="text-no-login">
          <h6 class="text-black-shadow">{{$t('SHOP.CART-EMPTY')}}</h6>
        </div>
        <div v-else style="padding: 2.6rem 0rem 2.6rem 0rem">
          <CartTotal :quantity="cart.quantity" :total="cart.total"></CartTotal>
          <Product v-for="(product, index) in cart.products_cart"
            :key="product.id"
            :data="product"
            :autoFocus="index === 0"
            v-on:deleteProduct="deleteModal($event)"
            v-on:modifyProduct="modifyModal($event)">
          </Product>

          <Modal v-if="showModal" @close="closeModal">
            <!-- modal dialog -->
            <p v-if="showModal === 'delete'" slot="body">{{$t("SHOP.MSG-DELETE")}}</p>

            <div v-if="showModal === 'modify'" slot="body">
              <div class="feature modal-focusable" v-on:keyup.left="decreaseQuantity" v-on:keyup.right="increaseQuantity">
                <span class="feature-name">Cantidad: </span>
                <div v-on:click="decreaseQuantity" class="icon"><icon name="caret-left" scale='2' class='icon'></icon></div>
                <span class="feature-value">{{quantityForm}}</span>
                <div v-on:click="increaseQuantity" class="icon"><icon name="caret-right" scale='2' class='icon'></icon></div>
              </div>

              <div v-for="feature in featuresForm" :key="feature.feature" class="feature modal-focusable" v-on:keyup.left="previousValue(feature)" v-on:keyup.right="nextValue(feature)">
                <span class="feature-name">{{feature.feature_name}}: </span>
                <div v-on:click="previousValue(feature)" class="icon"><icon name="caret-left" scale='2' class='icon'></icon></div>
                <span class="feature-value">{{feature.selected_value_name}}</span>
                <div v-on:click="nextValue(feature)" class="icon"><icon name="caret-right" scale='2' class='icon'></icon></div>
              </div>
            </div>
          </Modal>

        </div>
      </div>

      <!-- control bar -->
      <ControlBar v-if="$store.getters.getData.control_bar && $store.getters.platform !== 'browser'" :keys="keys" />

      <div id="back-browser-root" ref="back" class="back-browser fadein-browser"
      @click="back" v-if="$store.getters.platform === 'browser'" v-show="$route.name !== 'cart'">
        <icon name="arrow-left"></icon>
      </div>

    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import SpatialNavigation from 'js-spatial-navigation'
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import Product from '@/components/CartProduct'
import {StatsRootCart} from '@/utils/constants'
import Modal from '@/components/Modal'
import ControlBar from '@/components/ControlBar'
import CartTotal from '@/components/CartTotal'
const productsService = require('@/services/products.js')

export default {
  name: 'Cart',
  components: { Loader, Product, Modal, CartTotal, ControlBar },
  data () {
    return {
      cart: false,
      selectId: false,
      selectProduct: false,
      selectSN: false,
      showModal: false,
      quantityForm: 1,
      featuresForm: [],
      stockForm: 0,
      keys: [
        {text: this.$i18n.t('KEYS.EXIT'), action: this.$i18n.t('KEYS.CLOSE')},
        {text: this.$i18n.t('KEYS.OK'), action: this.$i18n.t('KEYS.SELECT')},
        {color: 'red', action: this.$i18n.t('KEYS.TOP')}
      ],
      setInterval: false,
      time: 0
    }
  },
  watch: {
    $route: function () {
      if (this.$route.name === 'cart') {
        SpatialNavigation.focus()
        SpatialNavigation.resume()
      }
    }
  },
  created: function () {
    if (this.$store.getters.user) {
      // PRODUCTOS
      if (this.$store.getters.getData.type_shop === 'A2C') {
        // compra api2cart
        productsService.getCartA2C().then(response => {
          this.cart = this.parseCartA2C(response.data.products)
          if (!this.cart.products_cart.length) { SpatialNavigation.resume(); SpatialNavigation.focus() }

          // alertas
          for (var i = 0; i < response.data.alerts.length; i++) {
            M.toast({html: response.data.alerts[i].message, classes: 'green lighten-1'})
          }
        })
      } else {
        // compra interna
        productsService.getCart().then(response => {
          this.cart = response.data['results'][0]
          if (!this.cart.products_cart.length) { SpatialNavigation.resume(); SpatialNavigation.focus() }
        })
      }
    } else { SpatialNavigation.resume(); SpatialNavigation.focus() }
    // keys control
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-red', this.keyRed)
  },
  beforeMount: function () {
    window.Countly.q.push(['track_pageview', StatsRootCart])
    window.scrollTo(0, 0)
  },
  mounted: function () {
    // back browser
    if (this.$store.getters.platform === 'browser') {
      this.setInterval = setInterval(() => {
        this.time = this.time + 1
        if (this.time >= 3 && this.$refs.back) {
          this.$refs.back.classList.remove('fadein-browser')
          this.$refs.back.classList.add('fadeout-browser')
        }
      }, 1000)

      this.$el.addEventListener('mousemove', () => {
        if (this.$refs.back) {
          this.$refs.back.classList.remove('fadeout-browser')
          this.$refs.back.classList.add('fadein-browser')
        }
        this.time = 0
      })
    }
  },
  methods: {
    parseCartA2C: function (products) {
      let cart = {
        products_cart: [],
        quantity: products.length,
        total: 0 // *** averiguar ????
      }

      let total = 0
      for (var i = 0; i < products.length; i++) {
        let img = products[i].item_image
        let options = []

        for (let j = 0; j < products[i].options.length; j++) {
          options.push({
            id: products[i].options[j].id, // id correcto?
            name: products[i].options[j].name,
            value: products[i].options[j].value
          })
        }

        let product = {
          id: products[i].id,
          price: products[i].item_price,
          quantity: products[i].item_quantity,
          options: options,
          features: [], // antiguo
          product: {
            id: products[i].item_id,
            name: products[i].item_name,
            description: products[i].product_detail.short_description.replace(/<\/?[^>]+>/ig, ' '),
            image: img
          }
        }

        total += products[i].item_price * products[i].item_quantity
        cart.products_cart.push(product)
      }
      cart.total = total

      return cart
    },
    back: function () { this.$router.go(-1) },
    keyBack () {
      if (this.$route.name === 'cart' && !this.showModal) {
        this.$router.replace({name: 'content'})
      }
    },
    keyRed () {
      if (this.$route.name === 'cart' && this.$store.getters.getData.control_bar && this.$store.getters.platform !== 'browser') { SpatialNavigation.focus() }
    },
    deleteModal: function (e) {
      SpatialNavigation.pause()
      this.selectId = e.id
      this.selectSN = e.sn
      this.showModal = 'delete'
    },
    deleteProduct: function (e) {
      if (this.$store.getters.getData.type_shop === 'A2C') {
        // compra api2cart
        SpatialNavigation.pause()
        this.cart = false
        productsService.removeFromCartA2C(this.selectId).then(response => {
          productsService.getCartA2C().then(response => {
            this.cart = this.parseCartA2C(response.data.products)
            if (!this.cart.products_cart.length) { SpatialNavigation.resume(); SpatialNavigation.focus() }
          })
        })
      } else {
        // compra interna
        SpatialNavigation.pause()
        this.cart = false
        productsService.removeFromCart(this.selectId).then(response => {
          productsService.getCart().then(response => {
            this.cart = response.data['results'][0]
            if (!this.cart.products_cart.length) { SpatialNavigation.resume(); SpatialNavigation.focus() }
          })
        })
      }
    },
    modifyModal: function (e) {
      SpatialNavigation.pause()
      this.selectId = e.id
      this.selectProduct = e.product
      this.selectSN = e.sn

      // initFeatures
      let featureValues = []
      for (var i = 0; i < e.product.features.length; ++i) {
        // valores por defecto (primer elemento)
        let selectedValue = e.product.features[i].values[0].id
        let selectedValueName = e.product.features[i].values[0].value

        // valores seleccionados (en caso de haberlo)
        for (var j = 0; j < e.features.length; ++j) {
          if (e.product.features[i].id === e.features[j].feature.id) {
            selectedValue = e.features[j].selected_value.id
            selectedValueName = e.features[j].selected_value.value
          }
        }

        featureValues.push({
          feature: e.product.features[i].id,
          feature_name: e.product.features[i].name,
          selected_value: selectedValue,
          selected_value_name: selectedValueName,
          temp_selected_value: selectedValue,
          temp_selected_value_name: selectedValueName,
          values: e.product.features[i].values
        })
      }
      // this.$modal.show('modal-form-product', { quantity: e.quantity, stock: e.product.stock, features: featureValues })
      this.stockForm = e.product.stock
      this.quantityForm = e.quantity
      this.featuresForm = featureValues
      this.showModal = 'modify'
    },
    modifyProduct: function (e) {
      SpatialNavigation.pause()
      this.cart = false

      let product = {
        product: this.selectProduct.id,
        features: this.featuresForm,
        quantity: this.quantityForm
      }

      productsService.putFromCart(this.selectId, product).then(response => {
        productsService.getCart().then(response => {
          this.cart = response.data['results'][0]
          if (!this.cart.products_cart.length) { SpatialNavigation.resume(); SpatialNavigation.focus() }
        })
      })
    },
    closeModal: function (event) {
      if (event.action && this.showModal === 'delete') {
        this.showModal = false
        this.deleteProduct()
      } else if (event.action && this.showModal === 'modify') {
        this.showModal = false
        this.modifyProduct()
      } else {
        SpatialNavigation.focus(this.selectSN)
        this.selectId = false
        this.selectProduct = false
        this.selectSN = false
        SpatialNavigation.resume()
        this.showModal = false
      }
    },
    // modal forms methods
    decreaseQuantity () {
      if (this.quantityForm > 1) this.quantityForm--
    },
    increaseQuantity () {
      if (this.quantityForm < this.stockForm) this.quantityForm++
    },
    previousValue (feature) {
      for (var i = 0; i < feature.values.length; ++i) {
        if (feature.values[i].id === feature.selected_value && typeof (feature.values[i - 1]) !== 'undefined') {
          feature.selected_value = feature.values[i - 1].id
          feature.selected_value_name = feature.values[i - 1].value
        }
      }
    },
    nextValue (feature) {
      for (var i = 0; i < feature.values.length; ++i) {
        if (feature.values[i].id === feature.selected_value && typeof (feature.values[i + 1]) !== 'undefined') {
          feature.selected_value = feature.values[i + 1].id
          feature.selected_value_name = feature.values[i + 1].value
        }
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.setInterval)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-red', this.keyRed)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  width: 100%;
  min-height: calc(100vh - 75px);
  min-height: -o-calc(100vh - 75px); // opera
  min-height: -webkit-calc(100vh - 75px); // google, safari
  min-height: -moz-calc(100vh - 75px); // firefox

.text-no-login
  position: relative
  max-width: 60vw
  min-height: 100%
  padding-top: 15rem
  margin: auto
  text-align: center

h6
  font-size: 2.3rem

</style>



// WEBPACK FOOTER //
// src/pages/cart/Cart.vue